// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3E5Zj","image":"classes_image__37_2N","subtitle":"classes_subtitle__3eY-A","text":"classes_text__9dQ3v","no-margin":"classes_no-margin__RXsUZ"};